import React from "react"

class ArticleBio extends React.Component {

  render() {

    const {author} = this.props,
          {authorAvatar} = this.props,
          {authorBio} = this.props

    return (
      <div className="article__bio">
        <div className="container">
          <div className="article__bio-content">
            <div className="article__bio-avatar">
              <img src={authorAvatar.publicURL} width="96" height="96" alt={author} />
            </div>
            <div className="article__bio-text">
              <p>{author}</p>
              <div dangerouslySetInnerHTML={{ __html: authorBio}} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ArticleBio